import { Agent, AgentId } from '../agent/types';
import { Query } from '../../design-system/types';
import { useGetAgents } from '../agent/hooks';
import { parseQueryString } from '../../shared/utilities/queryString';

export const useDisplayedAgentFromFilter = (dossierAgentId: AgentId): Agent | undefined => {
    const filterQuery = parseQueryString(location.search) as Query;
    const { data: agents } = useGetAgents();

    if (!filterQuery.agentId) {
        // By default, we display only assigned dossier of current agent and don't display other agents data
        return undefined;
    }

    // query is agentId='all' OR agentId=123&agentId=456..
    return agents?.[dossierAgentId];
};
